import React, { FC, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import { PageDataLoadContextProviderProps } from './PageDataLoadContextProvider.types';
import { PageDataLoadContext, PageDataLoadContextValue } from './context';
import { usePreloadPageDataCallback } from './hooks';
import { PageLoadData } from './types';

const PageDataLoadContextProvider: FC<PageDataLoadContextProviderProps> = ({ dataLoader, children }) => {
  const [pageLoadData, setPageLoadData] = useState<PageLoadData>(undefined);
  const preloadPageData = usePreloadPageDataCallback(setPageLoadData);
  const routeParams = useParams();

  useMemo(() => {
    if (dataLoader) {
      preloadPageData(dataLoader, routeParams);
    }
  }, [dataLoader, preloadPageData, routeParams]);

  const value = useMemo<PageDataLoadContextValue>(
    () => ({
      pageLoadData,
    }),
    [pageLoadData]
  );

  return <PageDataLoadContext.Provider value={value}>{children}</PageDataLoadContext.Provider>;
};

export default PageDataLoadContextProvider;
